const ChevronUpIcon = ({ className = '' }: { className?: string }) => (
  <svg
    aria-hidden='true'
    className={className}
    width='12'
    height='8'
    viewBox='0 0 12 8'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M12 6.6L10.6 8L6 3.4L1.4 8L-6.11959e-08 6.6L6 0.6L12 6.6V6.6Z'
      fill='currentColor'
    />
  </svg>
);

export default ChevronUpIcon;
